import clsx from "clsx";
import type { PropsWithChildren, ReactNode } from "react";

export const PortfolioToolbar = ({
  tabs,
  className,
  children,
}: PropsWithChildren<{ tabs: ReactNode; className?: string }>) => (
  <div className={clsx("tabs portfolio__toolbar mt-4", className)}>
    <span className="tabs portfolio__tabs">{tabs}</span>
    <span className="tabs portfolio__controls">{children}</span>
  </div>
);
